<div class="card card-transaction">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4 class="card-title">{{ "MENU.MY_SUPPORT_REQUEST" | translate }}</h4>
    <a *ngIf="ticket_list.length > 0" routerLink="/dashboard/ticket/my-list">{{ "VIEW_ALL_FEMALE" | translate }}</a>
  </div>
  <div class="card-body" *ngIf="ticket_list && ticket_list.length > 0; else noTicket">
    <div class="mb-1" *ngFor="let item of ticket_list">
      <div class="ticket-item" [ngbTooltip]="item.enabled_label" placement="left">
        <div class="bg-{{ item.steps[0].status === 0 ? 'secondary' : item.steps[0].status === 1 ? 'warning' : 'success' }}"></div>
        <div>
          <a class="font-weight-medium text-break-line-1" [routerLink]="'/dashboard/ticket/my-list'" [queryParams]="{ id: item.id }">{{ item.title }}</a>
          <small class="d-block">{{ "INSERT_DATE" | translate }}: {{ _utilsService.formatDate(item.insert_date) }}</small>
          <small *ngIf="item.last_step && item.last_step.status > 0">{{ "LAST_UPDATE" | translate }}: {{ _utilsService.formatDate(item.last_step.insert_date) }}</small>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mt-2">
      <a class="btn btn-outline-primary text-primary" (click)="_utilsService.popupOpenTicketIsOpen = !_utilsService.popupOpenTicketIsOpen">
        {{ "MENU.OPEN_SUPPORT_REQUEST" | translate }}
      </a>
    </div>
  </div>
  <ng-template #noTicket>
    <div class="card-body" *ngIf="!ticket_list || ticket_list.length < 1">
      <div>
        {{ "NOT_ONE_SUPPORT_REQUEST" | translate }}
      </div>
      <div class="d-flex align-items-center mt-2">
        <div class="flex-basis-80">
          <a class="btn btn-outline-primary text-primary" (click)="_utilsService.popupOpenTicketIsOpen = !_utilsService.popupOpenTicketIsOpen">
            {{ "MENU.OPEN_SUPPORT_REQUEST" | translate }}
          </a>
        </div>
      </div>
    </div>
  </ng-template>
</div>
